.cardText {
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-areas: 'firstLine review';
  gap: 4px 8px;
  margin-top: 16px;
}

.reviews {
  grid-area: review;
  display: flex;
  align-items: center;

  /* max-lines = 1 */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.line--first {
  grid-area: firstLine;
}

.line--full {
  grid-column-start: span 2;
}
